export default [
  {
    path: '/vistoria/:vistoriaId/veiculo-ambiente/:ambienteId/item-new',
    name: 'ItemCreateVeiculo',
    component: () => import('./VeiculoItensForm'),
    meta: {
      routerBack: '/vistoria/:vistoriaId/veiculo-ambiente/:ambienteId/item',
      domain: 'Item',
      sidebar: false,
      title: 'Novo item',
      icon: 'keyboard_backspace',
    },
  },
  {
    name: 'Editar item veiculo',
    path: '/vistoria/:vistoriaId/item-edit/:id',
    meta: {
      sidebar: false,
      routerBack: '/vistoria/:vistoriaId/item',
      domain: 'Item',
      title: 'Editar item',
      icon: 'keyboard_backspace',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Veiculos/Vistoria/Ambiente/Itens/ItensForm/VeiculoItemFormRouter.js